import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getNLForm = async ({ id, formstackId }: { id?: string; formstackId?: string }) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      id,
      formstackId,
    },
    query: graphql(`
      query GetNLForm($id: String, $formstackId: String) {
        getNLForm(id: $id, formstackId: $formstackId) {
          id
          formstackId
          createdAt
          updatedAt
          alternativePhoneNumber1
          alternativePhoneNumber2
          approvedByUm
          bestCallBackTime
          callerId
          cashAmountPaid
          correctDropOffAddress
          correctPickupAddress
          customersName
          customerCurrentTime
          dateOfRefundCredit
          details
          didTheClientSeeOrMeetTheDriver
          didTheClientSpeakWithTheDriver
          didTheDriverAttemptToCallUs
          didWeAttemptToCallTheClient
          driverNameAndNumber
          driverNoWantForGoGo
          driversLicensePlateNumber
          emailAddress
          endingAddress
          goGoCredits
          goGoingSince
          goGoRefund
          nameOfFacility
          natureOfComplaint
          operatorsName
          partnerCode
          phoneNumber
          reason
          reasonForClosing
          reasonForNotUsingOrNotNeedingService
          reasonForSuspending
          requestedMembershipRefund
          requestId
          returnAddress
          returnAddressType
          serviceType
          specialNotesForRefund
          startingAddress
          statusOfComplaint
          supervisorName
          supervisorNotesUpdates
          suspendEndDate
          suspendStartDate
          typeOfAlternativeTransportation
          typeOfCancellation
          uberLyftRefund
          vasName
          vendorRefunded
          wasTheClientWaitingOutsideIfNotWhereWasTheClientWaiting
          whereWasTheClientWaiting
          whichVendorWasThisTripWith
          whosCallingPhoneNumber
          customerConcern
          resolution
          offer
          retained
          callDuration
          moodOfCustomer
          needFollowUp
          wasRefundApprovedOrDeny
          adjustmentType
          membershipRefundIssued
          membershipCreditsIssued
          refundIssued
          creditsIssued
          deniedAmount
        }
      }
    `),
  });

  return response.data.getNLForm;
};
